import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChainsEnum } from '@/config';
import { AmlTraceRequest } from '@/api';

export interface AmlTraceState {
  traces: Record<string, any[]>;
  currencies: ChainsEnum[];
  loading: boolean;
  error: string | null;
  activeUuid: string | null;
}

const initialState: AmlTraceState = {
  traces: {},
  currencies: [],
  loading: false,
  error: null,
  activeUuid: null,
};

const amlTraceSlice = createSlice({
  name: 'amlTraces',
  initialState,
  reducers: {
    startTrace: (state, _action: PayloadAction<AmlTraceRequest>) => ({
      ...state,
      loading: true,
      error: null,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setError: (state, action: PayloadAction<string | null>) => ({
      ...state,
      error: action.payload,
    }),
    addTraceUpdate: (
      state,
      action: PayloadAction<{ uuid: string; data: any }>,
    ) => {
      const { uuid, data } = action.payload;
      if (!state.traces[uuid]) {
        state.traces[uuid] = [];
      }

      if (data) {
        state.traces[uuid].push(data);
      }
    },
    clearTrace: (state, action: PayloadAction<string>) => {
      delete state.traces[action.payload];
    },
    clearAllTraces: () => initialState,
    setCurrencies: (state, action: PayloadAction<ChainsEnum[]>) => ({
      ...state,
      currencies: action.payload,
    }),
    fetchCurrencies: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    setActiveUuid: (state, action: PayloadAction<string | null>) => {
      state.activeUuid = action.payload;
    },
  },
});

export { amlTraceSlice };
